import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { ArticuloMovimiento } from "@/shared/types/articulo-movimiento";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function deleteArticuloMovimiento(id: string): Promise<ArticuloMovimiento> {
    await sleep(1000);
    const response = await api.delete("articulo_movimientos/" + id);
    return response.data;
}

export function useDeleteArticuloMovimientoMutation(id: string, mutationConfig: MutationConfig<ArticuloMovimiento> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async () => await deleteArticuloMovimiento(id),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["articulo_movimientos"] });
        },
    })
}

export interface DeleteArticuloMovimientoMutationProps{
    id: string, 
    mutationConfig?: MutationConfig<ArticuloMovimiento>,
    children?:(mutationResult:MutationResult<ArticuloMovimiento>)=>ReactNode
}

export function DeleteArticuloMovimientoMutation({
    id,
    children,
    mutationConfig
}:DeleteArticuloMovimientoMutationProps){
    const mutationResult = useDeleteArticuloMovimientoMutation(id, mutationConfig);
    return children&&children(mutationResult)
}